import { InjectionToken } from '@angular/core';

export let TOASTR_TOKEN: InjectionToken<any> = new InjectionToken<any>('toastr');
